import { Download } from "react-feather";
import ModalBasic from "../../components/infrastructure/Modals/ModalBasic";
import PrimaryButton from "../../components/infrastructure/Buttons/PrimaryButton";
import { FaLink } from "react-icons/fa6";
const DocumentPreview = ({
    previewModalOpen,
    setPreviewModalOpen,
    previewImg = [],
}) => {
    console.log("previewImg", previewImg);
    // const isArray = Array.isArray(previewImg)
    // const previewImages = isArray ? previewImg : [previewImg];
    // console.log("previewImages", previewImages)
    // console.log("isArray", isArray)
    return (
        <ModalBasic
            modalOpen={previewModalOpen}
            setModalOpen={setPreviewModalOpen}
            title="Document Preview"
            max_width="max-w-5xl"
        >
            <div className="relative overflow-y-auto ">
                {previewImg?.length > 0 ? (
                    <>
                        {previewImg?.map((img, index) => (
                            <div
                                key={index}
                                className="relative flex justify-center items-center p-4"
                            >
                                {/* Download Button */}
                                <PrimaryButton
                                    className="absolute right-6 bottom-6 z-10"
                                    onClick={() => {
                                        if (!img) return;

                                        const fileUrl = `${process.env.REACT_APP_S3_URL}${img}`;

                                        window.open(fileUrl, "_blank");
                                    }}
                                >
                                    <FaLink size={16} />
                                </PrimaryButton>

                                {/* Image */}
                                <img
                                    src={`${process.env.REACT_APP_S3_URL}${img}`}
                                    alt={`Preview-${index}`}
                                    className="w-full h-auto object-contain rounded-lg border"
                                    style={{ maxHeight: "75vh" }}
                                />
                            </div>
                        ))}
                    </>
                ) : (
                    <div className="flex items-center justify-center h-[300px] text-gray-500">
                        No Preview Available
                    </div>
                )}
            </div>
        </ModalBasic>
    );
};

export default DocumentPreview;